import React from "react";

const Arrow = ({ direction, isEnd, click }) => {
  switch (direction) {
    case "LEFT":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={isEnd ? "gray" : "#3ACBF6"}
          onClick={click}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
          />
        </svg>
      );
    case "RIGHT":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={isEnd ? "gray" : "#3ACBF6"}
          onClick={click}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
          />
        </svg>
      );
    default:
      return null;
  }
};

export default Arrow;
